import { useTranslation } from '@ukpostbox/frontend-framework';
import { useMailbox } from '../../../Mailboxes/Providers/NewMailboxProvider';
import ForwardingBatchItemMinimal from '../../../Mailboxes/Components/ForwardingBatchEntries/ForwardingBatchItemMinimal';

function InForwardingBatchInfo() {
	const { t } = useTranslation();
	const { mailItemData } = useMailbox();

	if (!mailItemData?.forwardingBatch) return null;

	return (
		<div className='mt-lg'>
			<h6 className='pageantry-sub-heading text-left'>{t('mailItem.labels.inBatch')}</h6>
			<div className='forwarding-batch-rows-minimal'>
				<ForwardingBatchItemMinimal
					{...mailItemData?.forwardingBatch}
					files={[
						{
							category: '',
							mailPart: 0,
							userFile: {
								tokenRequired: false,
								fileName: '',
								linkToFile: '',
								status: [],
							},
							id: '',
							versionId: '',
							topupRequired: false,
							isLocked: false,
							userFileThumbnails: [
								{
									linkToFile: mailItemData?.forwardingBatch?.thumbnails[0],
									fileWidth: 0,
									fileSize: 0,
									status: [],
									fileName: '',
									fileHeight: 0,
									fileHash: '',
									fileExtension: '',
									fileDimension: 0,
									blurHash: '',
									tokenRequired: false,
								},
								{
									linkToFile: mailItemData?.forwardingBatch.thumbnails[1],
									fileWidth: 0,
									fileSize: 0,
									status: [],
									fileName: '',
									fileHeight: 0,
									fileHash: '',
									fileExtension: '',
									fileDimension: 0,
									blurHash: '',
									tokenRequired: false,
								},
								{
									linkToFile: mailItemData?.forwardingBatch.thumbnails[2],
									fileWidth: 0,
									fileSize: 0,
									status: [],
									fileName: '',
									fileHeight: 0,
									fileHash: '',
									fileExtension: '',
									fileDimension: 0,
									blurHash: '',
									tokenRequired: false,
								},
							],
						},
					]}
				/>
			</div>
		</div>
	);
}

export { InForwardingBatchInfo };
